import ExternalTransportBaseScreen from "./shared/externalTransport/ExternalTransportBaseScreen";

export const TransportBase = ({ modalData }: { modalData: any }) => (
  <ExternalTransportBaseScreen modalData={modalData} variant="mapping" />
);
